import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/categories/dispenser.svg")